export default {
  edit: {
    title: 'تعديل الملف الشخصي',
    subTitle: 'نموذج التعديل',
    editInformation: 'تعديل معلوماتي',
    sexOptionLabel: {
      male: 'ذكر',
      female: 'أنثى',
      unknown: 'غير محدد'
    },
    notifyMessage: 'تم التعديل بنجاح'
  },
  changePassword: {
    title: 'تغيير كلمة المرور',
    subTitle: 'أدخل كلمة المرور القديمة. ثم أدخل كلمة المرور الجديدة مرتين.',
    lastPassword: 'أدخل كلمة المرور القديمة',
    newPassword: 'أدخل كلمة المرور الجديدة',
    notifyMessage: 'تم التعديل بنجاح',
    notifyMessageError: 'لم يتم التعديل، تحقق من كلمة المرور'
  }
}
